import { gql } from "lib/apolloClient";
import { incidentFragment } from "./IncidentFragments";

export const updateIncidentMutation = gql`
  mutation updateIncident($input: UpdateBehaviourIncidentInput!) {
    platform {
      updateBehaviourIncident(input: $input) {
        ...incidentDetails
      }
    }
  }
  ${incidentFragment.incidentDetailsFragment}
`;

export const createBehaviourIncidentMutation = gql`
  mutation createBehaviourIncident($input: CreateBehaviourIncidentInput) {
    platform {
      createBehaviourIncident(input: $input) {
        ...incidentDetails
      }
    }
  }
  ${incidentFragment.incidentDetailsFragment}
`;

export const deleteBehaviourIncidentMutation = gql`
  mutation deleteBehaviourIncident($input: DeleteBehaviourIncidentInput!) {
    platform {
      deleteBehaviourIncident(input: $input)
    }
  }
`;

export const discardBehaviourIncidentMutation = gql`
  mutation discardBehaviourIncident($input: DiscardBehaviourIncidentInput!) {
    platform {
      discardBehaviourIncident(input: $input)
    }
  }
`;

export const duplicateBehaviourIncidentMutation = gql`
  mutation duplicateBehaviourIncident(
    $input: DuplicateBehaviourIncidentInput!
  ) {
    platform {
      duplicateBehaviourIncident(input: $input) {
        id
      }
    }
  }
`;
